export default __webpack_public_path__ + "static/media/seguridad.f3657894.jpg";